export default "__VITE_ASSET__D9jh3fvY__"